export const ERROR_SOURCES = {
  HELP_TOPICS: 'helpTopics',
  SAVED_SEARCH: 'savedSearch',
};

export const FORBIDDEN_PERMISSION_ERROR_CODES = ['50135', '50501'];
